<template>
    <div>

        <strong><a :name="anchorComputed"><slot name="question"></slot></a></strong>
        <slot></slot>
        <br><br><br>
    </div>
</template>

<script>
    export default {
        name: 'Faq-Item',
        props: ['anchor'],
        computed: {
            anchorComputed: {
                get: function() {
                    return this.anchor || this.question.replace(/[^a-zA-Z0-9]/g, "");
                }
            }
        },
        data () {
            return {
                question: "",
                answer: "",
            }
        }
    }
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/Faq-Item.vue